/* eslint-disable no-magic-numbers */
interface ITextureData {
	x: number;
	y: number;
	width: number;
	height: number;
}

// exportovane textury
const wasmTexturePoisMapping = new Map<number, ITextureData>();

wasmTexturePoisMapping.set(622, { x: 0, y: 0, width: 40, height: 40 });
wasmTexturePoisMapping.set(167, { x: 40, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(398, { x: 0, y: 40, width: 30, height: 30 });
wasmTexturePoisMapping.set(402, { x: 30, y: 40, width: 30, height: 30 });
wasmTexturePoisMapping.set(405, { x: 70, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(408, { x: 70, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(157, { x: 0, y: 70, width: 30, height: 30 });
wasmTexturePoisMapping.set(901, { x: 30, y: 70, width: 30, height: 30 });
wasmTexturePoisMapping.set(902, { x: 60, y: 70, width: 30, height: 30 });
wasmTexturePoisMapping.set(1003, { x: 100, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(450, { x: 100, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(47, { x: 100, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(403, { x: 0, y: 100, width: 30, height: 30 });
wasmTexturePoisMapping.set(451, { x: 30, y: 100, width: 30, height: 30 });
wasmTexturePoisMapping.set(404, { x: 60, y: 100, width: 30, height: 30 });
wasmTexturePoisMapping.set(120, { x: 90, y: 100, width: 30, height: 30 });
wasmTexturePoisMapping.set(153, { x: 130, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(935, { x: 130, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(939, { x: 130, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(452, { x: 130, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(485, { x: 0, y: 130, width: 30, height: 30 });
wasmTexturePoisMapping.set(374, { x: 30, y: 130, width: 30, height: 30 });
wasmTexturePoisMapping.set(494, { x: 60, y: 130, width: 30, height: 30 });
wasmTexturePoisMapping.set(28, { x: 90, y: 130, width: 30, height: 30 });
wasmTexturePoisMapping.set(10, { x: 120, y: 130, width: 30, height: 30 });
wasmTexturePoisMapping.set(937, { x: 160, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(938, { x: 160, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(383, { x: 160, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(399, { x: 160, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(495, { x: 160, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(130, { x: 0, y: 160, width: 30, height: 30 });
wasmTexturePoisMapping.set(419, { x: 30, y: 160, width: 30, height: 30 });
wasmTexturePoisMapping.set(100, { x: 60, y: 160, width: 30, height: 30 });
wasmTexturePoisMapping.set(109, { x: 90, y: 160, width: 30, height: 30 });
wasmTexturePoisMapping.set(968, { x: 120, y: 160, width: 30, height: 30 });
wasmTexturePoisMapping.set(1004, { x: 150, y: 160, width: 30, height: 30 });
wasmTexturePoisMapping.set(1041, { x: 190, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(400, { x: 190, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(166, { x: 190, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(456, { x: 190, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(496, { x: 190, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(401, { x: 190, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(304, { x: 0, y: 190, width: 30, height: 30 });
wasmTexturePoisMapping.set(422, { x: 30, y: 190, width: 30, height: 30 });
wasmTexturePoisMapping.set(497, { x: 60, y: 190, width: 30, height: 30 });
wasmTexturePoisMapping.set(407, { x: 90, y: 190, width: 30, height: 30 });
wasmTexturePoisMapping.set(498, { x: 120, y: 190, width: 30, height: 30 });
wasmTexturePoisMapping.set(1005, { x: 150, y: 190, width: 30, height: 30 });
wasmTexturePoisMapping.set(1042, { x: 180, y: 190, width: 30, height: 30 });
wasmTexturePoisMapping.set(1075, { x: 220, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(454, { x: 220, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(1080, { x: 220, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(1081, { x: 220, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(1113, { x: 220, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(1114, { x: 220, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(1155, { x: 220, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(1156, { x: 0, y: 220, width: 30, height: 30 });
wasmTexturePoisMapping.set(1190, { x: 30, y: 220, width: 30, height: 30 });
wasmTexturePoisMapping.set(1192, { x: 60, y: 220, width: 30, height: 30 });
wasmTexturePoisMapping.set(1277, { x: 90, y: 220, width: 30, height: 30 });
wasmTexturePoisMapping.set(1363, { x: 120, y: 220, width: 30, height: 30 });
wasmTexturePoisMapping.set(453, { x: 150, y: 220, width: 30, height: 30 });
wasmTexturePoisMapping.set(173, { x: 180, y: 220, width: 30, height: 30 });
wasmTexturePoisMapping.set(425, { x: 210, y: 220, width: 30, height: 30 });
wasmTexturePoisMapping.set(499, { x: 250, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(500, { x: 250, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(115, { x: 250, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(1006, { x: 250, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(1076, { x: 250, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(455, { x: 250, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(501, { x: 250, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(502, { x: 250, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(503, { x: 0, y: 250, width: 30, height: 30 });
wasmTexturePoisMapping.set(221, { x: 30, y: 250, width: 30, height: 30 });
wasmTexturePoisMapping.set(457, { x: 60, y: 250, width: 30, height: 30 });
wasmTexturePoisMapping.set(335, { x: 90, y: 250, width: 30, height: 30 });
wasmTexturePoisMapping.set(439, { x: 120, y: 250, width: 30, height: 30 });
wasmTexturePoisMapping.set(506, { x: 150, y: 250, width: 30, height: 30 });
wasmTexturePoisMapping.set(504, { x: 180, y: 250, width: 30, height: 30 });
wasmTexturePoisMapping.set(144, { x: 210, y: 250, width: 30, height: 30 });
wasmTexturePoisMapping.set(200, { x: 240, y: 250, width: 30, height: 30 });
wasmTexturePoisMapping.set(507, { x: 280, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(508, { x: 280, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(255, { x: 280, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(265, { x: 280, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(267, { x: 280, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(95, { x: 280, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(505, { x: 280, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(458, { x: 280, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(338, { x: 280, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(850, { x: 0, y: 280, width: 30, height: 30 });
wasmTexturePoisMapping.set(98, { x: 30, y: 280, width: 30, height: 30 });
wasmTexturePoisMapping.set(509, { x: 60, y: 280, width: 30, height: 30 });
wasmTexturePoisMapping.set(68, { x: 90, y: 280, width: 30, height: 30 });
wasmTexturePoisMapping.set(1077, { x: 120, y: 280, width: 30, height: 30 });
wasmTexturePoisMapping.set(1115, { x: 150, y: 280, width: 30, height: 30 });
wasmTexturePoisMapping.set(459, { x: 180, y: 280, width: 30, height: 30 });
wasmTexturePoisMapping.set(340, { x: 210, y: 280, width: 30, height: 30 });
wasmTexturePoisMapping.set(510, { x: 240, y: 280, width: 30, height: 30 });
wasmTexturePoisMapping.set(460, { x: 270, y: 280, width: 30, height: 30 });
wasmTexturePoisMapping.set(462, { x: 310, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(346, { x: 310, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(465, { x: 310, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(469, { x: 310, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(1078, { x: 310, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(1147, { x: 310, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(1148, { x: 310, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(511, { x: 310, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(461, { x: 310, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(468, { x: 310, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(479, { x: 0, y: 310, width: 30, height: 30 });
wasmTexturePoisMapping.set(463, { x: 30, y: 310, width: 30, height: 30 });
wasmTexturePoisMapping.set(102, { x: 60, y: 310, width: 30, height: 30 });
wasmTexturePoisMapping.set(464, { x: 90, y: 310, width: 30, height: 30 });
wasmTexturePoisMapping.set(466, { x: 120, y: 310, width: 30, height: 30 });
wasmTexturePoisMapping.set(345, { x: 150, y: 310, width: 30, height: 30 });
wasmTexturePoisMapping.set(467, { x: 180, y: 310, width: 30, height: 30 });
wasmTexturePoisMapping.set(471, { x: 210, y: 310, width: 30, height: 30 });
wasmTexturePoisMapping.set(250, { x: 240, y: 310, width: 30, height: 30 });
wasmTexturePoisMapping.set(168, { x: 270, y: 310, width: 30, height: 30 });
wasmTexturePoisMapping.set(426, { x: 300, y: 310, width: 30, height: 30 });
wasmTexturePoisMapping.set(1079, { x: 340, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(1149, { x: 340, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(1150, { x: 340, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(1151, { x: 340, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(470, { x: 340, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(472, { x: 340, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(473, { x: 340, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(474, { x: 340, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(1152, { x: 340, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(1157, { x: 340, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(1193, { x: 340, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(1194, { x: 0, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(1195, { x: 30, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(475, { x: 60, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(480, { x: 90, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(49, { x: 120, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(477, { x: 150, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(26, { x: 180, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(481, { x: 210, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(482, { x: 240, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(96, { x: 270, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(146, { x: 300, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(427, { x: 330, y: 340, width: 30, height: 30 });
wasmTexturePoisMapping.set(158, { x: 370, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(1153, { x: 370, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(1196, { x: 370, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(1279, { x: 370, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(1364, { x: 370, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(1365, { x: 370, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(483, { x: 370, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(484, { x: 370, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(486, { x: 370, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(488, { x: 370, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(551, { x: 370, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(489, { x: 370, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(428, { x: 0, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(429, { x: 30, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(188, { x: 60, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(51, { x: 90, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(62, { x: 120, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(139, { x: 150, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(266, { x: 180, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(269, { x: 210, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(430, { x: 240, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(23, { x: 270, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(780, { x: 300, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(803, { x: 330, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(1229, { x: 360, y: 370, width: 30, height: 30 });
wasmTexturePoisMapping.set(1263, { x: 400, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(435, { x: 400, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(45, { x: 400, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(447, { x: 400, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(35, { x: 400, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(56, { x: 400, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(179, { x: 400, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(92, { x: 400, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(205, { x: 400, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(196, { x: 400, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(222, { x: 400, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(432, { x: 400, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(197, { x: 400, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(781, { x: 0, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(201, { x: 30, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(193, { x: 60, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(1264, { x: 90, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(1267, { x: 120, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(1268, { x: 150, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(170, { x: 180, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(178, { x: 210, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(191, { x: 240, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(104, { x: 270, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(52, { x: 300, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(1265, { x: 330, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(1266, { x: 360, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(124, { x: 390, y: 400, width: 30, height: 30 });
wasmTexturePoisMapping.set(268, { x: 430, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(337, { x: 430, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(343, { x: 430, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(344, { x: 430, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(169, { x: 430, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(25, { x: 430, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(448, { x: 430, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(449, { x: 430, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(171, { x: 430, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(180, { x: 430, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(172, { x: 430, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(175, { x: 430, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(176, { x: 430, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(182, { x: 430, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(183, { x: 0, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(177, { x: 30, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(181, { x: 60, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(476, { x: 90, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(8, { x: 120, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(184, { x: 150, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(103, { x: 180, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(487, { x: 210, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(185, { x: 240, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(186, { x: 270, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(36, { x: 300, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(3, { x: 330, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(11, { x: 360, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(22, { x: 390, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(24, { x: 420, y: 430, width: 30, height: 30 });
wasmTexturePoisMapping.set(558, { x: 460, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(27, { x: 460, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(30, { x: 460, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(34, { x: 460, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(31, { x: 460, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(32, { x: 460, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(37, { x: 460, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(38, { x: 460, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(39, { x: 460, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(44, { x: 460, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(187, { x: 460, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(190, { x: 460, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(50, { x: 460, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(43, { x: 460, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(206, { x: 460, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(231, { x: 0, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(189, { x: 30, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(46, { x: 60, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(1362, { x: 90, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(194, { x: 120, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(53, { x: 150, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(54, { x: 180, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(782, { x: 210, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(55, { x: 240, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(57, { x: 270, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(58, { x: 300, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(59, { x: 330, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(60, { x: 360, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(61, { x: 390, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(195, { x: 420, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(198, { x: 450, y: 460, width: 30, height: 30 });
wasmTexturePoisMapping.set(207, { x: 490, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(223, { x: 490, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(63, { x: 490, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(64, { x: 490, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(65, { x: 490, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(66, { x: 490, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(67, { x: 490, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(69, { x: 490, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(70, { x: 490, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(71, { x: 490, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(75, { x: 490, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(804, { x: 490, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(199, { x: 490, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(243, { x: 490, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(72, { x: 490, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(73, { x: 490, y: 450, width: 30, height: 30 });
wasmTexturePoisMapping.set(76, { x: 0, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(83, { x: 30, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(84, { x: 60, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(1230, { x: 90, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(87, { x: 120, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(491, { x: 150, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(208, { x: 180, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(242, { x: 210, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(89, { x: 240, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(805, { x: 270, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(94, { x: 300, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(490, { x: 330, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(88, { x: 360, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(204, { x: 390, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(1269, { x: 420, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(209, { x: 450, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(233, { x: 480, y: 490, width: 30, height: 30 });
wasmTexturePoisMapping.set(90, { x: 520, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(224, { x: 520, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(235, { x: 520, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(239, { x: 520, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(91, { x: 520, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(93, { x: 520, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(97, { x: 520, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(99, { x: 520, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(101, { x: 520, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(105, { x: 520, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(106, { x: 520, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(112, { x: 520, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(113, { x: 520, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(108, { x: 520, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(110, { x: 520, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(111, { x: 520, y: 450, width: 30, height: 30 });
wasmTexturePoisMapping.set(121, { x: 520, y: 480, width: 30, height: 30 });
wasmTexturePoisMapping.set(1002, { x: 0, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(114, { x: 30, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(117, { x: 60, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(118, { x: 90, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(119, { x: 120, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(122, { x: 150, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(123, { x: 180, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(125, { x: 210, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(225, { x: 240, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(232, { x: 270, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(20, { x: 300, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(126, { x: 330, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(129, { x: 360, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(133, { x: 390, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(226, { x: 420, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(237, { x: 450, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(127, { x: 480, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(131, { x: 510, y: 520, width: 30, height: 30 });
wasmTexturePoisMapping.set(227, { x: 550, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(236, { x: 550, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(128, { x: 550, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(132, { x: 550, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(228, { x: 550, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(238, { x: 550, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(5, { x: 550, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(135, { x: 550, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(134, { x: 550, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(136, { x: 550, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(137, { x: 550, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(138, { x: 550, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(140, { x: 550, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(150, { x: 550, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(155, { x: 550, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(141, { x: 550, y: 450, width: 30, height: 30 });
wasmTexturePoisMapping.set(613, { x: 550, y: 480, width: 30, height: 30 });
wasmTexturePoisMapping.set(142, { x: 550, y: 510, width: 30, height: 30 });
wasmTexturePoisMapping.set(148, { x: 0, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(149, { x: 30, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(156, { x: 60, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(143, { x: 90, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(145, { x: 120, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(147, { x: 150, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(151, { x: 180, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(152, { x: 210, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(154, { x: 240, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(159, { x: 270, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(160, { x: 300, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(164, { x: 330, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(229, { x: 360, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(161, { x: 390, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(162, { x: 420, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(163, { x: 450, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(165, { x: 480, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(230, { x: 510, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(240, { x: 540, y: 550, width: 30, height: 30 });
wasmTexturePoisMapping.set(774, { x: 580, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(253, { x: 580, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(273, { x: 580, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(283, { x: 580, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(241, { x: 580, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(254, { x: 580, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(259, { x: 580, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(261, { x: 580, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(244, { x: 580, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(258, { x: 580, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(262, { x: 580, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(286, { x: 580, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(245, { x: 580, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(260, { x: 580, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(264, { x: 580, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(285, { x: 580, y: 450, width: 30, height: 30 });
wasmTexturePoisMapping.set(289, { x: 580, y: 480, width: 30, height: 30 });
wasmTexturePoisMapping.set(246, { x: 580, y: 510, width: 30, height: 30 });
wasmTexturePoisMapping.set(263, { x: 580, y: 540, width: 30, height: 30 });
wasmTexturePoisMapping.set(270, { x: 0, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(282, { x: 30, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(247, { x: 60, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(13, { x: 90, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(271, { x: 120, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(279, { x: 150, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(280, { x: 180, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(248, { x: 210, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(249, { x: 240, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(251, { x: 270, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(272, { x: 300, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(288, { x: 330, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(290, { x: 360, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(295, { x: 390, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(296, { x: 420, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(297, { x: 450, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(291, { x: 480, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(16, { x: 510, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(293, { x: 540, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(306, { x: 570, y: 580, width: 30, height: 30 });
wasmTexturePoisMapping.set(309, { x: 610, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(292, { x: 610, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(307, { x: 610, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(310, { x: 610, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(312, { x: 610, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(313, { x: 610, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(329, { x: 610, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(294, { x: 610, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(298, { x: 610, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(299, { x: 610, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(301, { x: 610, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(302, { x: 610, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(303, { x: 610, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(305, { x: 610, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(308, { x: 610, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(311, { x: 610, y: 450, width: 30, height: 30 });
wasmTexturePoisMapping.set(314, { x: 610, y: 480, width: 30, height: 30 });
wasmTexturePoisMapping.set(317, { x: 610, y: 510, width: 30, height: 30 });
wasmTexturePoisMapping.set(322, { x: 610, y: 540, width: 30, height: 30 });
wasmTexturePoisMapping.set(354, { x: 610, y: 570, width: 30, height: 30 });
wasmTexturePoisMapping.set(358, { x: 0, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(315, { x: 30, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(330, { x: 60, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(334, { x: 90, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(355, { x: 120, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(357, { x: 150, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(316, { x: 180, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(614, { x: 210, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(320, { x: 240, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(321, { x: 270, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(331, { x: 300, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(332, { x: 330, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(333, { x: 360, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(336, { x: 390, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(347, { x: 420, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(341, { x: 450, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(734, { x: 480, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(342, { x: 510, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(348, { x: 540, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(349, { x: 570, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(350, { x: 600, y: 610, width: 30, height: 30 });
wasmTexturePoisMapping.set(351, { x: 640, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(352, { x: 640, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(356, { x: 640, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(360, { x: 640, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(362, { x: 640, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(353, { x: 640, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(359, { x: 640, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(361, { x: 640, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(783, { x: 640, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(363, { x: 640, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(364, { x: 640, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(367, { x: 640, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(388, { x: 640, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(784, { x: 640, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(365, { x: 640, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(375, { x: 640, y: 450, width: 30, height: 30 });
wasmTexturePoisMapping.set(377, { x: 640, y: 480, width: 30, height: 30 });
wasmTexturePoisMapping.set(379, { x: 640, y: 510, width: 30, height: 30 });
wasmTexturePoisMapping.set(368, { x: 640, y: 540, width: 30, height: 30 });
wasmTexturePoisMapping.set(369, { x: 640, y: 570, width: 30, height: 30 });
wasmTexturePoisMapping.set(371, { x: 640, y: 600, width: 30, height: 30 });
wasmTexturePoisMapping.set(372, { x: 0, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(397, { x: 30, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(373, { x: 60, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(376, { x: 90, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(385, { x: 120, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(412, { x: 150, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(378, { x: 180, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(434, { x: 210, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(895, { x: 240, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(444, { x: 270, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(380, { x: 300, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(381, { x: 330, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(382, { x: 360, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(395, { x: 390, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(896, { x: 420, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(445, { x: 450, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(897, { x: 480, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(387, { x: 510, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(389, { x: 540, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(537, { x: 570, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(785, { x: 600, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(390, { x: 630, y: 640, width: 30, height: 30 });
wasmTexturePoisMapping.set(415, { x: 670, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(421, { x: 670, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(696, { x: 670, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(424, { x: 670, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(396, { x: 670, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(410, { x: 670, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(807, { x: 670, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(391, { x: 670, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(411, { x: 670, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(414, { x: 670, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(786, { x: 670, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(440, { x: 670, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(441, { x: 670, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(416, { x: 670, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(417, { x: 670, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(418, { x: 670, y: 450, width: 30, height: 30 });
wasmTexturePoisMapping.set(423, { x: 670, y: 480, width: 30, height: 30 });
wasmTexturePoisMapping.set(528, { x: 670, y: 510, width: 30, height: 30 });
wasmTexturePoisMapping.set(420, { x: 670, y: 540, width: 30, height: 30 });
wasmTexturePoisMapping.set(442, { x: 670, y: 570, width: 30, height: 30 });
wasmTexturePoisMapping.set(787, { x: 670, y: 600, width: 30, height: 30 });
wasmTexturePoisMapping.set(512, { x: 670, y: 630, width: 30, height: 30 });
wasmTexturePoisMapping.set(513, { x: 0, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(545, { x: 30, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(514, { x: 60, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(515, { x: 90, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(516, { x: 120, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(518, { x: 150, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(519, { x: 180, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(520, { x: 210, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(522, { x: 240, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(524, { x: 270, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(521, { x: 300, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(523, { x: 330, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(525, { x: 360, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(526, { x: 390, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(527, { x: 420, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(2, { x: 450, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(19, { x: 480, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(21, { x: 510, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(529, { x: 540, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(15, { x: 570, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(1, { x: 600, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(4, { x: 630, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(6, { x: 660, y: 670, width: 30, height: 30 });
wasmTexturePoisMapping.set(18, { x: 700, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(7, { x: 700, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(530, { x: 700, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(531, { x: 700, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(536, { x: 700, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(17, { x: 700, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(532, { x: 700, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(533, { x: 700, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(538, { x: 700, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(539, { x: 700, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(540, { x: 700, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(541, { x: 700, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(542, { x: 700, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(535, { x: 700, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(544, { x: 700, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(534, { x: 700, y: 450, width: 30, height: 30 });
wasmTexturePoisMapping.set(547, { x: 700, y: 480, width: 30, height: 30 });
wasmTexturePoisMapping.set(546, { x: 700, y: 510, width: 30, height: 30 });
wasmTexturePoisMapping.set(898, { x: 700, y: 540, width: 30, height: 30 });
wasmTexturePoisMapping.set(548, { x: 700, y: 570, width: 30, height: 30 });
wasmTexturePoisMapping.set(1280, { x: 700, y: 600, width: 30, height: 30 });
wasmTexturePoisMapping.set(552, { x: 700, y: 630, width: 30, height: 30 });
wasmTexturePoisMapping.set(553, { x: 700, y: 660, width: 30, height: 30 });
wasmTexturePoisMapping.set(816, { x: 0, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(891, { x: 30, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(1272, { x: 60, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(554, { x: 90, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(555, { x: 120, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(556, { x: 150, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(557, { x: 180, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(559, { x: 210, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(560, { x: 240, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(561, { x: 270, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(562, { x: 300, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(517, { x: 330, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(1313, { x: 360, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(564, { x: 390, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(565, { x: 420, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(563, { x: 450, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(566, { x: 480, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(567, { x: 510, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(1314, { x: 540, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(568, { x: 570, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(569, { x: 600, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(570, { x: 630, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(571, { x: 660, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(1315, { x: 690, y: 700, width: 30, height: 30 });
wasmTexturePoisMapping.set(1316, { x: 730, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(1318, { x: 730, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(300, { x: 730, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(1317, { x: 730, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(572, { x: 730, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(573, { x: 730, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(574, { x: 730, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(575, { x: 730, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(884, { x: 730, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(576, { x: 730, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(609, { x: 730, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(610, { x: 730, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(611, { x: 730, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(612, { x: 730, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(885, { x: 730, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(887, { x: 730, y: 450, width: 30, height: 30 });
wasmTexturePoisMapping.set(888, { x: 730, y: 480, width: 30, height: 30 });
wasmTexturePoisMapping.set(1346, { x: 730, y: 510, width: 30, height: 30 });
wasmTexturePoisMapping.set(615, { x: 730, y: 540, width: 30, height: 30 });
wasmTexturePoisMapping.set(788, { x: 730, y: 570, width: 30, height: 30 });
wasmTexturePoisMapping.set(791, { x: 730, y: 600, width: 30, height: 30 });
wasmTexturePoisMapping.set(792, { x: 730, y: 630, width: 30, height: 30 });
wasmTexturePoisMapping.set(794, { x: 730, y: 660, width: 30, height: 30 });
wasmTexturePoisMapping.set(810, { x: 730, y: 690, width: 30, height: 30 });
wasmTexturePoisMapping.set(616, { x: 0, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(617, { x: 30, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(618, { x: 60, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(619, { x: 90, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(620, { x: 120, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(886, { x: 150, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(889, { x: 180, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(1347, { x: 210, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(549, { x: 240, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(550, { x: 270, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(621, { x: 300, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(789, { x: 330, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(793, { x: 360, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(624, { x: 390, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(625, { x: 420, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(626, { x: 450, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(623, { x: 480, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(790, { x: 510, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(795, { x: 540, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(890, { x: 570, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(627, { x: 600, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(1349, { x: 630, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(1348, { x: 660, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(431, { x: 690, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(433, { x: 720, y: 730, width: 30, height: 30 });
wasmTexturePoisMapping.set(446, { x: 760, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(443, { x: 760, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(438, { x: 760, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(436, { x: 760, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(796, { x: 760, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(798, { x: 760, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(808, { x: 760, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(811, { x: 760, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(892, { x: 760, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(437, { x: 760, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(660, { x: 760, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(693, { x: 760, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(694, { x: 760, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(695, { x: 760, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(729, { x: 760, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(731, { x: 760, y: 450, width: 30, height: 30 });
wasmTexturePoisMapping.set(732, { x: 760, y: 480, width: 30, height: 30 });
wasmTexturePoisMapping.set(733, { x: 760, y: 510, width: 30, height: 30 });
wasmTexturePoisMapping.set(730, { x: 760, y: 540, width: 30, height: 30 });
wasmTexturePoisMapping.set(764, { x: 760, y: 570, width: 30, height: 30 });
wasmTexturePoisMapping.set(797, { x: 760, y: 600, width: 30, height: 30 });
wasmTexturePoisMapping.set(766, { x: 760, y: 630, width: 30, height: 30 });
wasmTexturePoisMapping.set(799, { x: 760, y: 660, width: 30, height: 30 });
wasmTexturePoisMapping.set(809, { x: 760, y: 690, width: 30, height: 30 });
wasmTexturePoisMapping.set(893, { x: 760, y: 720, width: 30, height: 30 });
wasmTexturePoisMapping.set(765, { x: 0, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(767, { x: 30, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(800, { x: 60, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(768, { x: 90, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(802, { x: 120, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(806, { x: 150, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(770, { x: 180, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(771, { x: 210, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(772, { x: 240, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(773, { x: 270, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(769, { x: 300, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(775, { x: 330, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(776, { x: 360, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(777, { x: 390, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(778, { x: 420, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(779, { x: 450, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(801, { x: 480, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(9, { x: 510, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(812, { x: 540, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(813, { x: 570, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(814, { x: 600, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(384, { x: 630, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(386, { x: 660, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(815, { x: 690, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(849, { x: 720, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(894, { x: 750, y: 760, width: 30, height: 30 });
wasmTexturePoisMapping.set(1036, { x: 790, y: 0, width: 30, height: 30 });
wasmTexturePoisMapping.set(1037, { x: 790, y: 30, width: 30, height: 30 });
wasmTexturePoisMapping.set(900, { x: 790, y: 60, width: 30, height: 30 });
wasmTexturePoisMapping.set(1038, { x: 790, y: 90, width: 30, height: 30 });
wasmTexturePoisMapping.set(1039, { x: 790, y: 120, width: 30, height: 30 });
wasmTexturePoisMapping.set(1040, { x: 790, y: 150, width: 30, height: 30 });
wasmTexturePoisMapping.set(85, { x: 790, y: 180, width: 30, height: 30 });
wasmTexturePoisMapping.set(86, { x: 790, y: 210, width: 30, height: 30 });
wasmTexturePoisMapping.set(1191, { x: 790, y: 240, width: 30, height: 30 });
wasmTexturePoisMapping.set(1397, { x: 790, y: 270, width: 30, height: 30 });
wasmTexturePoisMapping.set(1356, { x: 790, y: 300, width: 30, height: 30 });
wasmTexturePoisMapping.set(1271, { x: 790, y: 330, width: 30, height: 30 });
wasmTexturePoisMapping.set(1273, { x: 790, y: 360, width: 30, height: 30 });
wasmTexturePoisMapping.set(1276, { x: 790, y: 390, width: 30, height: 30 });
wasmTexturePoisMapping.set(492, { x: 790, y: 420, width: 30, height: 30 });
wasmTexturePoisMapping.set(493, { x: 790, y: 450, width: 30, height: 30 });
wasmTexturePoisMapping.set(1274, { x: 790, y: 480, width: 30, height: 30 });
wasmTexturePoisMapping.set(543, { x: 790, y: 510, width: 30, height: 30 });
wasmTexturePoisMapping.set(1278, { x: 790, y: 540, width: 30, height: 30 });
wasmTexturePoisMapping.set(1275, { x: 790, y: 570, width: 30, height: 30 });
wasmTexturePoisMapping.set(1357, { x: 790, y: 600, width: 30, height: 30 });
wasmTexturePoisMapping.set(1358, { x: 790, y: 630, width: 30, height: 30 });
wasmTexturePoisMapping.set(1360, { x: 790, y: 660, width: 30, height: 30 });
wasmTexturePoisMapping.set(1359, { x: 790, y: 690, width: 30, height: 30 });
wasmTexturePoisMapping.set(1361, { x: 790, y: 720, width: 30, height: 30 });
wasmTexturePoisMapping.set(339, { x: 790, y: 750, width: 20, height: 19 });

export default function getWasmPoisTexturesData(poiId: number): ITextureData | null {
	return wasmTexturePoisMapping.get(poiId) || null;
}
